// eslint-disable-next-line no-unused-vars
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { digObject } from 'functions/utilities'
import filteredObjectArraySelector from 'functions/filteredObjectArraySelector'

import useSetState from 'hooks/useSetState'

const getSelectedQuote = (props, state) => {
  const { selectedQuoteId } = state
  const { campaignQuotes } = props

  if (selectedQuoteId){
    return campaignQuotes.find(quote => quote.id === selectedQuoteId)
  }

  return campaignQuotes[0] || {}
}

const defaultState = {
  selectedQuoteId: null,
}

const CampaignQuotesWrapper = (props) => {
  const [state, setState] = useSetState(defaultState)

  const { campaignQuotes, render, campaignQuoteIds } = props

  if (!campaignQuoteIds.length){
    return null
  }

  const campaignQuote = getSelectedQuote(props, state)

  return render({
    campaignQuote,
    campaignQuotes,
    selectQuoteId: value => setState({ selectedQuoteId: value }),
    selectedQuoteId: campaignQuote.id,
  })
}

CampaignQuotesWrapper.propTypes = {
  campaignQuoteIds: PropTypes.array.isRequired,
  campaignQuotes: PropTypes.array.isRequired,
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { dataSource } = props
  const campaignQuoteIds = digObject(dataSource, 'options.campaign_quote_ids', [])

  return {
    campaignQuoteIds,
    campaignQuotes: filteredObjectArraySelector(state, 'campaignQuotes', 'id', campaignQuoteIds),
  }
}

export default connect(mapStateToProps)(CampaignQuotesWrapper)
